// import { Fragment, useEffect } from 'react';
import { Fragment } from 'react';
// import App from 'next/app';
// import type { AppProps, AppContext } from 'next/app';
import type { AppProps } from 'next/app';
import Script from 'next/script';
import dynamic from 'next/dynamic';
import Head from 'next/head';

import Layout from '@/components/Layout';
import useShare from '@/hooks/useShare';
import MTHead from '@/components/MTHead'
const DynamicVConsole = dynamic(() => import('@/components/VConsole'), { ssr: false, });

// import { setUserInfo } from '@/store/user';
// import { xhrCheckLogin } from '@/http/api/account/account';
// import { TUserInfoR } from '@/http/api/account';

// import { getNodeCookie } from '@/utils/toolsNew';
// import { COOKIE_KEY_ANALYZER_WCY_ID } from '@/utils/constant';
// import { isDev } from '@/utils/toolsNew';

import '@/styles/globals.scss';
import '@/utils/live/plugin/pluginError.css';



const props = { 
  stock_title: '', 
  head_title: '', 
  head_author: '', 
  head_keywords: '', 
  head_desc: '', 
  title: '', 
  link: '', 
  desc: '', 
  imgUrl: '' 
};



// type TPageProps = {
//   userInfo?: TUserInfoR | null;
// }

function MyApp({ Component, pageProps }: AppProps) {

  useShare(); // 微信 分享

  // useEffect(() => {
  //   if (typeof window !== 'undefined' && pageProps.userInfo) {
      
  //     setUserInfo(pageProps.userInfo);
  //   }
  // }, []);

  return (
    <Fragment>
      <Head>
        <meta
          content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover'
          name='viewport'
        />
      </Head>
      <MTHead { ...props} />
      <Layout>
        <Component {...pageProps} />
      </Layout>

      <DynamicVConsole />
      <Script
        id='baiduTrack'
        src='https://hm.baidu.com/hm.js?153e44351ad5a88ad19d447d93188b28'
        strategy='beforeInteractive'
      />
      <Script
        id='geeTest'
        src='https://s1-static.huxiucdn.com/common/gt/gt4.js'
        strategy='beforeInteractive'
      />
    </Fragment>
  );
}

// Only uncomment this method if you have blocking data requirements for
// every single page in your application. This disables the ability to
// perform automatic static optimization, causing every page in your app to
// be server-side rendered.
//
// MyApp.getInitialProps = async (appContext: AppContext) => {
//   // calls page's `getInitialProps` and fills `appProps.pageProps`
//   const appProps = await App.getInitialProps(appContext);

//   let serverCookie = '';
//   let userInfo = { wcyCookie: '' } as TUserInfoR;

//   if (appContext.ctx.req) {
//     serverCookie = appContext.ctx.req.headers.cookie || '';
//   }
  
//   const res = await xhrCheckLogin(serverCookie);
//   if (res.success) {
//     userInfo = res.data;
//   } else {
//     userInfo.wcyCookie = res.error.wcyCookie
//   }
//   /**
//    * 在无痕模式下（用户从没有打开过.huxiu.com相关页面）huxiu_analyzer_wcy_id 这个cookie会在前面几个接口没有传给服务端，最直接的报错 就是调用 /live/userWatchLog 会返回不成功，因为这个接口必须要传递这个cookie
//    */
//   const tempCookieKey = getNodeCookie(serverCookie, COOKIE_KEY_ANALYZER_WCY_ID);
//   if (!tempCookieKey && appContext.ctx.res) {
//     appContext.ctx.res.setHeader('Set-Cookie', `${COOKIE_KEY_ANALYZER_WCY_ID}=${userInfo.wcyCookie}; Path=/; Max-Age=${60 * 60 * 24 * 365}; Domain=.huxiu.com; ${!isDev ? 'Secure;' : ''}`)
//   }
  
//   return { ...appProps, pageProps: { ...appProps.pageProps, userInfo } }
// }

// TODO:性能指标分析
// eslint-disable-next-line
// export function reportWebVitals(metric: any) {
//   // console.log(metric);
// }

export default MyApp;
